import React from "react";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Accordion from "@visa/vds/accordion";
import AccordionBody from "@visa/vds/accordion-body";
import AccordionItem from "@visa/vds/accordion-item";
import AccordionHeading from "@visa/vds/accordion-heading";
import AccordionTitle from "@visa/vds/accordion-title";
import Typography from "@visa/vds/typography";
import FormControl from "@visa/vds/form-control";
import TextArea from "@visa/vds/textarea";
import MCSReadonlyField from "../MCSReadonlyField";
import OrderReferenceAccordionBody from "../order/OrderReferenceAccordionBody";
import { DateHelper } from "../../_helpers/DateHelper";
import { UserRole } from "../../_constants/UserRole";

const CancellationReferenceAccordion = (props) => {
  const subscription = props.subscription;

  let cancelledByUser = subscription.cancelledByUser;
  let cancelledBy = cancelledByUser.fullName;
  if (cancelledByUser.entitleId === UserRole.UserExternal_Entitlement && cancelledByUser.isSubscriptionManager) {
    cancelledBy += " (Subscription Manager)";
  } else {
    cancelledBy += " (" + cancelledByUser.roleName + ")";
  }

  let showCancellationReason = props.showAdminCancellationReason || cancelledByUser.entitleId === UserRole.UserExternal_Entitlement;

  return (
    <Accordion
      id="accordion-subscription-cancel-reference"
      defaultExpandedId={[0]}
      allowMultipleExpanded={true}
    >
      <AccordionItem>
        <AccordionHeading>
          <AccordionTitle>Cancellation Reference</AccordionTitle>
        </AccordionHeading>
        <AccordionBody>
          <Row>
            <Col>
              <MCSReadonlyField
                label="Cancellation Date"
                text={DateHelper.ToFormattedDate(subscription.cancellationDate)}
              />
              <MCSReadonlyField label="Canceled By" text={cancelledBy} />
              {showCancellationReason && (
                <>
                  <Typography className="vss-field-label">
                    <b>Cancellation Reason:</b>
                  </Typography>
                  <FormControl position="left" space="fifty">
                    <TextArea
                      value={subscription.cancellationReason}
                      readOnly={true}
                    />
                  </FormControl>
                </>
              )}
            </Col>
          </Row>
        </AccordionBody>
      </AccordionItem>
      <AccordionItem>
        <AccordionHeading>
          <AccordionTitle>Order Reference</AccordionTitle>
        </AccordionHeading>
        <AccordionBody>
          <OrderReferenceAccordionBody
            order={subscription.order}
            showOrderNotes={props.showOrderNotes}
          />
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  );
};
export default CancellationReferenceAccordion;
